export const PERSISTED_AT_SET_VALUE = 'travelKe/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
